import './timerBadge.css';

const TimerBadge = ({ currentTime = 0, duration = 11000, size = 40, strokeWidth = 3 }) => {
  const hasTime = Number.isFinite(currentTime) && currentTime > 0;
  const hasDuration = Number.isFinite(duration) && duration > 0;
  const timeLeft = hasTime && hasDuration
    ? Math.max(0, Math.ceil((duration - currentTime) / 1000))
    : null;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const progress = hasTime && hasDuration
    ? (currentTime / duration) * circumference
    : 0;

  return (
    <div className="timer-badge" style={{ width: size, height: size }}>
      <svg width={size} height={size}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="rgba(77, 230, 35, 0.1)"
          strokeWidth={strokeWidth}
          fill="none"
        />
        <circle
          className="ring-fg"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="#4DE623"
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={progress}
          strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
      <span className="timer-text">{timeLeft == null ? '--' : timeLeft}</span>
    </div>
  );
};

export default TimerBadge;
